import { z } from 'zod'

export const productPurchaseModeSchema = z.enum([
  'cart',
  'cartInquiry',
  'inquiry',
])

export type ProductPurchaseMode = z.infer<typeof productPurchaseModeSchema>

export const resolveProductPurchaseMode = (
  purchaseMode?: string | null,
  inquireOnly?: boolean | null,
): ProductPurchaseMode => {
  if (purchaseMode === 'cartInquiry' || purchaseMode === 'inquiry' || purchaseMode === 'cart') {
    return purchaseMode
  }

  return inquireOnly ? 'inquiry' : 'cart'
}
